import { useState } from "react";
import Tippy from "@tippyjs/react";
import { hideAll } from "tippy.js";
import Program from "../../components/program/Program";
import { Link } from "react-router-dom";

const LazyTooltip = ({ program, selectedCategories }) => {
  const [shouldMount, setShouldMount] = useState(false);

  return (
    <Tippy
      content={
        shouldMount ? (
          <Program programm_id={program.programm_id} scheme={program.scheme} />
        ) : null
      }
      onShow={(instance) => {
        if (!shouldMount) setShouldMount(true);
        hideAll({ exclude: instance });
      }}
      appendTo={() => document.body}
      interactive={true}
      arrow={true}
      className="my-tooltip"
      placement="right"
      delay={0}
      duration={0}
      animation={false}
      popperOptions={{
        modifiers: [
          {
            name: "flip",
            options: {
              fallbackPlacements: ["left"],
            },
          },
        ],
      }}
    >
      <li
        className={
          (program.scheme.line !== null
            ? "tv-program__program--current "
            : "") +
          "tv-program__program" +
          selectedCategories
            .map((item) =>
              program.categories
                .map((elem) =>
                  item == elem ? ` tv-program__program--selected-${item}` : ""
                )
                .join("")
            )
            .join("")
        }
        data-category={program.categories}
      >
        <div className="tv-program__program-inner">
          <time
            className="tv-program__program-time"
            datetime={program.scheme.start_at.slice(-8)}
          >
            {program.scheme.start_at.slice(11, -3)}
          </time>
          <Link
            className="tv-program__program-name"
            to={`//telekarta.tv/tvprogram/program/${program.programm_id}`}
          >
            {program.name + (program.name_path ? `: ${program.name_path}` : "")}
          </Link>
        </div>
        {program.scheme.line === null ? (
          ""
        ) : (
          <div className="tv-program__program-progress">
            <div
              className="tv-program__program-progress-line"
              style={{
                transform: "translateX(0)",
                width: `${program.scheme.line.rate}%`,
              }}
            ></div>
          </div>
        )}
      </li>
    </Tippy>
  );
};

export default LazyTooltip;
